export default __webpack_public_path__ + "static/media/pictogramBeaconPrint40.01214523.svg";